import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class SystemAuditService {
  protected logoutUrl = '/hrm-portal-api/api/authentication/pre-logout';
  protected loginUrl = '/hrm-portal-api/api/authentication/post-login';

  /**
   * Constructor
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  postLogin() {
    // this._http.put<any>(this.loginUrl, {}).subscribe();
  }

  preLogout(): Observable<any> {
    return this._http.put<any>(this.logoutUrl, {});
  }
}
